// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs_breadcrumbs__n82hq","link":"breadcrumbs_link__Asi34 button_linkReset__LFkPu"};